import EcoImg from 'eco-design/base/eco-img';
import React, { useState } from 'react';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import EcoSpace from 'eco-design/base/eco-space';
import { getIsPadWidth } from '@elem/utils/devices';

const KSPPicture: React.FC = () => {
    const { t } = useLang('Delta3AirSeries.H');
    const isMobile = getIsPadWidth();

    return (
        <section className={`${styles.H} GtmModuleData-section range5`} id="List-sence-E" data-section-id="D3A-H">
            {!isMobile && <EcoSpace />}
            <div className="box">
                <div className="title">{t('title')}</div>
                <div className="desc">{t('desc')} </div>
                <div className="img">
                    <EcoImg
                        pc="https://websiteoss.ecoflow.com/upload/image/1763521758079/Frame%202094654541.jpg"
                        h5="https://websiteoss.ecoflow.com/upload/image/1763521810778/Frame%201612707427.jpg"
                        isOpenLazy
                    ></EcoImg>
                </div>
            </div>
        </section>
    );
};

export default KSPPicture;
